import * as React from "react";
import { useTranslation } from "react-i18next";
import { useIsOffline } from "~/config/offline-storage/useIsOffline.hook";
import { Button } from "~/design-system/Button";

type ResetFilterButtonProps = {
  onClick: () => void;
};

const ResetFilterButton = (props: ResetFilterButtonProps) => {
  const { t } = useTranslation();
  const isOffline = useIsOffline();

  return (
    <Button
      variant="ghost"
      onClick={props.onClick}
      dataClovisActionId="tasks-reset-filters"
      disabled={isOffline}
    >
      {t(
        "screens.ProjectTasksListScreen.ResetFilterButton.title",
        "Reset filters and see all tasks"
      )}
    </Button>
  );
};

export { ResetFilterButton };
